"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { useEffect, useState } from "react";
import type { KeyboardEvent as ReactKeyboardEvent } from "react";
import { SortDirection } from "@/entities/ISort";
import CommonTableSortIcon from "@/components/user/utils/icons/CommonTableSortIcon";
import type { CommonSelectItemProps } from "../CommonSelect";
export default function CommonTabsTab(props) {
  const $ = _c(45);
  const {
    item,
    activeItem,
    setSelected,
    sortDirection,
    onKeyDown,
    buttonRef,
    disabled: t0,
    fill: t1,
    size: t2
  } = props;
  const disabled = t0 === undefined ? false : t0;
  const fill = t1 === undefined ? true : t1;
  const size = t2 === undefined ? "md" : t2;
  let t3;
  if ($[0] !== activeItem || $[1] !== item.value) {
    t3 = () => item.value === activeItem;
    $[0] = activeItem;
    $[1] = item.value;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const getIsActive = t3;
  const [isActive, setIsActive] = useState(getIsActive());
  let t4;
  if ($[3] !== getIsActive) {
    t4 = () => {
      setIsActive(getIsActive());
    };
    $[3] = getIsActive;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== activeItem) {
    t5 = [activeItem];
    $[5] = activeItem;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== isActive) {
    t6 = () => {
      let response;
      if (isActive) {
        response = "tw-bg-iron-800 tw-text-iron-100";
      } else {
        response = " tw-bg-iron-950 hover:tw-bg-iron-900 tw-text-iron-500 hover:tw-text-iron-100";
      }
      return response;
    };
    $[7] = isActive;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const getDynamicClasses = t6;
  const [dynamicClasses, setDynamicClasses] = useState(getDynamicClasses());
  let t7;
  if ($[9] !== getDynamicClasses) {
    t7 = () => {
      setDynamicClasses(getDynamicClasses());
    };
    $[9] = getDynamicClasses;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isActive) {
    t8 = [isActive];
    $[11] = isActive;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  useEffect(t7, t8);
  const [shouldRotate, setShouldRotate] = useState(false);
  let t9;
  if ($[13] !== disabled || $[14] !== item.value || $[15] !== setSelected) {
    t9 = () => {
      if (disabled) {
        return;
      }
      setSelected(item.value);
      setShouldRotate(false);
    };
    $[13] = disabled;
    $[14] = item.value;
    $[15] = setSelected;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const onSelected = t9;
  const tooltip = "tooltip" in item && typeof item.tooltip === "string" ? item.tooltip : undefined;
  const t10 = fill ? "tw-flex-1" : undefined;
  let t11;
  if ($[17] !== t10) {
    t11 = clsx("tw-flex tw-rounded-lg tw-p-[1px]", t10, undefined);
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = isActive ? 0 : -1;
  let t13;
  let t14;
  if ($[19] !== disabled) {
    t13 = () => !disabled && setShouldRotate(true);
    t14 = () => !disabled && setShouldRotate(false);
    $[19] = disabled;
    $[20] = t13;
    $[21] = t14;
  } else {
    t13 = $[20];
    t14 = $[21];
  }
  const t15 = `${dynamicClasses} ${disabled ? "tw-cursor-not-allowed tw-opacity-60" : ""} ${fill ? "tw-flex-1" : ""} ${size === "sm" ? "tw-px-3 tw-py-1.5 tw-text-xs" : "tw-px-3 tw-py-1.5 tw-text-sm"} tw-flex tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-lg tw-border-0 tw-font-medium tw-leading-5 tw-transition-all tw-duration-300 tw-ease-out`;
  let t16;
  if ($[22] !== item.badge) {
    t16 = !!item.badge && item.badge > 0 && <span className="tw-flex tw-h-[18px] tw-min-w-[18px] tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-500 tw-px-1.5 tw-py-0.5 tw-text-[10px] tw-font-bold tw-text-white">{item.badge}</span>;
    $[22] = item.badge;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== isActive || $[25] !== shouldRotate || $[26] !== sortDirection) {
    t17 = sortDirection && <span className="-tw-mt-1"><CommonTableSortIcon direction={isActive ? sortDirection : SortDirection.DESC} isActive={isActive} shouldRotate={isActive && shouldRotate} /></span>;
    $[24] = isActive;
    $[25] = shouldRotate;
    $[26] = sortDirection;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== buttonRef || $[29] !== disabled || $[30] !== isActive || $[31] !== item.label || $[32] !== onKeyDown || $[33] !== onSelected || $[34] !== t12 || $[35] !== t13 || $[36] !== t14 || $[37] !== t15 || $[38] !== t16 || $[39] !== t17 || $[40] !== tooltip) {
    t18 = <button type="button" role="tab" aria-selected={isActive} tabIndex={t12} ref={buttonRef} title={tooltip} disabled={disabled} onClick={onSelected} onKeyDown={onKeyDown} onMouseEnter={t13} onMouseLeave={t14} className={t15}>{item.label}{t16}{t17}</button>;
    $[28] = buttonRef;
    $[29] = disabled;
    $[30] = isActive;
    $[31] = item.label;
    $[32] = onKeyDown;
    $[33] = onSelected;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
    $[40] = tooltip;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t11 || $[43] !== t18) {
    t19 = <div className={t11}>{t18}</div>;
    $[42] = t11;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
}